/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

export interface HeaderArgs {
  title: string;
  showSidebarToggle: boolean;
  isSideMenuOpen: boolean;
  openSideMenu: () => void;
}

interface Signature {
  Args: HeaderArgs;
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

export default class Header extends Component<Signature> {
  @service declare intercomEventService: $TSFixMe;

  @action handleOpenSideMenu() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'open_side_menu',
    });
    this.args.openSideMenu();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::Header': typeof Header;
  }
}
